import {motion,useReducedMotion} from 'framer-motion';
import {Link,useLocation} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BackgroundFX from './BackgroundFX';
import NewsletterPopup from './NewsletterPopup';
import {PROFILE_IMAGE_URL} from '../data/profileImage';
import '../linkBioEnhancements.css';

const {FiArrowUpRight,FiCoffee,FiMail,FiShoppingBag}=FiIcons;
const profileImage=PROFILE_IMAGE_URL;
const coffeeUrl='https://buymeacoffee.com/daddacool';
const coffeeBadge='https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png';
const merchUrl='https://shop.dadda.cool/';

function CoffeeHeaderBadge() {
  return (
    <a
      className="header-coffee-badge"
      href={coffeeUrl}
      target="_blank"
      rel="noreferrer"
      aria-label="Buy Dadda Cool a coffee"
      title="Buy Dadda Cool a coffee"
    >
      <img src={coffeeBadge} alt="Buy Dadda Cool a coffee" />
    </a>
  );
}

function MerchHeaderLink() {
  return (
    <a
      href={merchUrl}
      target="_blank"
      rel="noreferrer"
      className="inline-flex min-h-[34px] shrink-0 items-center gap-2 rounded-lg border border-[#64e8ce]/25 bg-[#171b24] px-3 text-[11px] font-bold text-[#f5f7fa] shadow-lg transition hover:-translate-y-0.5 hover:border-[#64e8ce]/55 hover:text-[#64e8ce]"
      aria-label="Shop Dadda Cool Merch"
      title="Dadda Cool Merch"
    >
      <SafeIcon icon={FiShoppingBag} className="h-4 w-4 text-[#64e8ce]" />
      <span>Dadda Cool Merch</span>
    </a>
  );
}

function FooterSupportCard({reduceMotion}) {
  return (
    <motion.a
      href={coffeeUrl}
      target="_blank"
      rel="noreferrer"
      className="newsletter-card"
      aria-label="Support Dadda Cool on Buy Me a Coffee"
      initial={reduceMotion ? false : {opacity: 0,y: 6}}
      whileInView={{opacity: 1,y: 0}}
      viewport={{once: true,margin: '-20px'}}
      transition={{duration: 0.24,ease: 'easeOut'}}
      whileTap={reduceMotion ? undefined : {scale: 0.98}}
    >
      <span className="newsletter-icon !border-yellow-300/20 !bg-yellow-300/10 !text-yellow-300">
        <SafeIcon icon={FiCoffee} />
      </span>
      <span className="newsletter-copy">
        <strong>Support Dadda Cool</strong>
        <small>Help make the next song,project and creative experiment.</small>
        <img
          className="mt-2 block w-[128px] rounded-md"
          src={coffeeBadge}
          alt="Buy Dadda Cool a coffee"
          loading="lazy"
        />
      </span>
      <SafeIcon icon={FiArrowUpRight} className="newsletter-arrow" />
    </motion.a>
  );
}

export default function PageShell({children}) {
  const {pathname}=useLocation();
  const reduceMotion=useReducedMotion();
  const isHome=pathname==='/';

  return (
    <main className="site-shell">
      <BackgroundFX />
      <div className="page-frame">
        {isHome ? (
          <div className="home-masthead !justify-between gap-3">
            <MerchHeaderLink />
            <CoffeeHeaderBadge />
          </div>
        ) : (
          <>
            <div className="compact-masthead !mb-2">
              <Link
                to="/"
                className="mini-brand mini-brand-avatar"
                aria-label="Return to Dadda Cool home"
              >
                <img src={profileImage} alt="" />
              </Link>
              <Link to="/" className="back-link">
                Back to links
              </Link>
            </div>
            <div className="mb-4 flex items-center justify-between gap-3">
              <MerchHeaderLink />
              <CoffeeHeaderBadge />
            </div>
          </>
        )}

        {children}

        <footer className="site-footer">
          <motion.a
            href="https://sendfox.com/daddacool"
            target="_blank"
            rel="noreferrer"
            className="newsletter-card"
            aria-label="Join the Dadda Cool newsletter"
            initial={reduceMotion ? false : {opacity: 0,y: 6}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true,margin: '-20px'}}
            transition={{duration: 0.24,ease: 'easeOut'}}
            whileTap={reduceMotion ? undefined : {scale: 0.98}}
          >
            <span className="newsletter-icon">
              <SafeIcon icon={FiMail} />
            </span>
            <span className="newsletter-copy">
              <strong>Join the newsletter</strong>
              <small>Fresh music,creator gear,and software finds.</small>
            </span>
            <SafeIcon icon={FiArrowUpRight} className="newsletter-arrow" />
          </motion.a>

          <FooterSupportCard reduceMotion={reduceMotion} />

          <span className="footer-branding">
            Dadda Cool · Links from the future
          </span>
        </footer>
      </div>
      <NewsletterPopup />
    </main>
  );
}